export default __webpack_public_path__ + "static/media/nectar white 1.b410da25.svg";